import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const initialAuthState = {
    monthIndex : dayjs().month(),
}


const calendarSlice = createSlice({
    name: "Calendar",
    initialState: initialAuthState,
    reducers: {
        next (state){
            state.monthIndex = state.monthIndex + 1
        },
        prev (state){
            state.monthIndex = state.monthIndex - 1
        }
    },
    
})

export const calendarActions = calendarSlice.actions;

export default calendarSlice.reducer;
